import type { IdeaStatusViewCardProps } from '../types';

const defaultViewProps: Partial<IdeaStatusViewCardProps> = {
  showIdeaCount: true
};

export default defaultViewProps;
